import { Heading } from './ui/Heading'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Image } from '@components/gassan-ui'
import { Button } from '@components/old-rolex-ui'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

type RCPOLandingPageHeroProps = {
  mobileImage: AssetsElement
  desktopImage: AssetsElement
  title: string
  buttonText: string
}

export const RCPOLandingPageHero: FC<RCPOLandingPageHeroProps> = ({
  mobileImage,
  desktopImage,
  title,
  buttonText,
}) => {
  const { t } = useTranslation('navigation')
  return (
    <div className="relative">
      <Image
        className="aspect-[13/20] w-full object-cover md:aspect-[12/5]"
        placeholder={getKontentImage(mobileImage.value[0].url, { width: 50 })}
        sources={[
          getKontentImage(mobileImage.value[0].url, { width: 768 }),
          getKontentImage(desktopImage.value[0].url, { width: 1200 }),
          getKontentImage(desktopImage.value[0].url, { width: 2000 }),
        ]}
        alt={mobileImage.value[0].description || ''}
      />
      <div className="absolute bottom-8 left-0 right-0 z-[2] mx-auto w-full max-w-[1500px] px-7 md:bottom-auto md:top-1/2 md:-translate-y-1/2 md:px-10">
        <Heading variant="large" as="h1" className="!mb-4 whitespace-pre-line !text-white">
          {title}
        </Heading>
        <LocalizedLink href={t(`rcpo.selection.url`, { ns: 'navigation' })}>
          <Button>{buttonText}</Button>
        </LocalizedLink>
      </div>
    </div>
  )
}
